import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import ContextMenu from './ContextMenu'
import { openContextMenu, closeContextMenu, registerContextMenu } from './contextMenuService'
import { useDispatch } from 'react-redux'
import { closeAdditionalMenu, openAdditionalMenu } from '../../store/ContentVideolists/actions'
import { store } from '../../connect'
import { clearTrackSummery, downloadTrackSummery } from '../../store/ContentAllVideolists/actions'

const getMenuConfig = (target, dispatch) => {
    if (target.closest('.AdditionalSettings_track')) {
        const Store = store.getState();
        const selected_videolists = Store.videolists_all.selected;
        const selected_videolist = Store.videolists_all.allVideolists.find(el => el.id === selected_videolists[0]);
        const selected_files = Store.videolists_all.selected_video;
        console.log({target: target.dataset});
        

        const showVideoLists = () => dispatch(downloadTrackSummery(selected_files.length ? selected_files : [Number(target?.dataset?.songId)]))
        const close = () => {
            closeContextMenu()
            dispatch(closeAdditionalMenu())

        }
        return {
            items:
                //  selected_videolist ? [  // если выделено больше 1
                //     { id: 'showPlaylist', label: 'Показать списки с этим файлом', callback: showVideoLists, close },
                //     { id: 'divider' },
                //     selected_files.length ? { id: 'deleteSelected', label: `Удалить выбранные (${selected_files.length}) из ${selected_videolist.name}` } : null,
                //     { id: 'delete', label: `Удалить из ${selected_videolist.name}` },
                // ] :
                [
                    { id: 'showPlaylist', label: 'Показать списки с этим файлом', callback: showVideoLists, close },
                    selected_files.length ? { id: 'deleteSelected', label: `Показать списки с выбранныи файлами`, callback: showVideoLists, close } : null,
                ]
        }

    }
    if (target.closest('.AdditionalSettings_videolist_all')) {

        const clear = () => dispatch(clearTrackSummery())

        const close = () => {
            closeContextMenu()
            dispatch(closeAdditionalMenu())

        }
        return {
            items:
                [
                    { id: 'showPlaylist', label: 'Отменить выделение', callback: clear, close },
                ]
        }

    }

    if (target.closest('.AdditionalSettings_someElse')) {
        return {
            items: [
                { id: 'open', label: 'Открыть' },
                { id: 'rename', label: 'Переименовать' },
                { id: 'divider' },
                { id: 'delete', label: 'Удалить', disabled: true }
            ]
        }
    }

    return null
}

const ContextMenuProvider = ({ children }) => {
    const menuRef = useRef(null)
    const dispatch = useDispatch();

    // ВЫНОСИМ ОБРАБОТЧИК, чтобы использовать и для ПКМ, и для ЛКМ
    const handleTrigger = (e, isClick = false) => {
        // Для ЛКМ: проверяем data-click="context"
        if (isClick) {
            const clickMode = e.target.closest('[data-click="context"]')
            if (!clickMode) return  // обычный клик — игнорируем
        }

        const trigger = e.target.closest('[class*="AdditionalSettings"]')
        
        if (!trigger) return

        const config = getMenuConfig(trigger, dispatch)
        if (!config) return

        e.preventDefault()
        e.stopPropagation()  // важно для ЛКМ, чтобы не всплывало
        e.stopImmediatePropagation()
        dispatch(openAdditionalMenu(trigger.dataset))

        // Для ЛКМ позиционируем относительно элемента, а не курсора
        const pos = isClick 
            ? { x: trigger.getBoundingClientRect().left, y: trigger.getBoundingClientRect().bottom }
            : { x: e.clientX, y: e.clientY }

        openContextMenu({ x: pos.x, y: pos.y, ...config })
    }

    useEffect(() => {
        if (menuRef.current) {
            registerContextMenu(menuRef.current)
        }

        // ПКМ — стандартное поведение
        const handleContextMenu = (e) => handleTrigger(e, false)

        // ЛКМ — только для [data-click="context"]
        const handleClick = (e) => {
            // Закрытие меню при клике вне (ваш текущий код)
            const menuEl = document.querySelector('.ctx-menu')
            if (menuEl && !menuEl.contains(e.target)) {
                closeContextMenu()
                dispatch(closeAdditionalMenu())
                return
            }
            
            // Новое: обработка ЛКМ-триггеров
            handleTrigger(e, true)
        }

        const handleKey = (e) => {
            if (e.key === 'Escape') {
                closeContextMenu()
                dispatch(closeAdditionalMenu())
            }
        }

        document.addEventListener('contextmenu', handleContextMenu)
        document.addEventListener('mousedown', handleClick)
        document.addEventListener('keydown', handleKey)

        return () => {
            document.removeEventListener('contextmenu', handleContextMenu)
            document.removeEventListener('mousedown', handleClick)
            document.removeEventListener('keydown', handleKey)
        }
    }, [dispatch])  // добавьте dispatch в deps

    return (
        <>
            {children}
            {ReactDOM.createPortal(
                <ContextMenu ref={menuRef} />,
                document.body
            )}
        </>
    )
}

export default ContextMenuProvider